module.exports = __webpack_public_path__ + "img/image-square.3c9cdc5c.svg";